import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { listVideos, resolveFileUrl } from '../lib/api';
import VideoCard from '../components/VideoCard';
import { useApp } from '../context/AppContext';
import { formatCount } from '../mock';
import { Loader2, Zap } from 'lucide-react';

export default function Category() {
  const { slug } = useParams();
  const { categories } = useApp();
  const [sort, setSort] = useState('recent');
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);

  const cat = (categories || []).find(c => c.slug === slug) || { name: slug || 'Category', slug };

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const params = { sort, limit: 100 };
        if (slug !== 'trending') params.category = slug;
        const arr = await listVideos(params);
        setList(arr);
      } finally { setLoading(false); }
    })();
  }, [slug, sort]);

  const isShorts = slug === 'shorts';

  return (
    <div>
      <div className="flex items-center gap-2 text-[13px] text-white/55">
        <Link to="/home" className="hover:text-white">Home</Link> <span>/</span> <span>{cat.name}</span>
      </div>
      <div className="flex items-center gap-3 mt-3">
        {isShorts && <div className="w-10 h-10 rounded-xl bg-[#ff2e63]/15 border border-[#ff2e63]/40 grid place-items-center"><Zap className="w-5 h-5 text-[#ff6b8a]" /></div>}
        <h1 className="font-display text-[36px] md:text-[48px] leading-none">{cat.name}</h1>
      </div>

      {isShorts && (
        <div className="mt-3">
          <Link to="/shorts" className="btn-primary inline-flex"><Zap className="w-4 h-4" /> Open Shorts player</Link>
        </div>
      )}

      <div className="mt-5 flex items-center gap-2">
        {[['recent','Recent'], ['views','Most viewed'], ['likes','Most liked']].map(([k, lb]) => (
          <button key={k} onClick={() => setSort(k)} className={`chip ${sort === k ? 'active' : ''}`}>{lb}</button>
        ))}
      </div>

      {loading ? (
        <div className="mt-6 flex items-center gap-2 text-white/60"><Loader2 className="w-5 h-5 animate-spin" /> Loading…</div>
      ) : isShorts ? (
        <div className="mt-6 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-3">
          {list.map(v => (
            <Link key={v.id} to={`/watch/${v.id}`} className="relative rounded-xl overflow-hidden ring-1 ring-white/10 hover-lift group" style={{ aspectRatio: '9/16' }}>
              <img src={resolveFileUrl(v.thumb)} alt={v.title} className="w-full h-full object-cover group-hover:scale-[1.03] transition-transform" />
              <div className="absolute inset-0" style={{ background: 'linear-gradient(0deg, rgba(0,0,0,0.8), rgba(0,0,0,0) 55%)' }} />
              <div className="absolute bottom-0 left-0 right-0 p-2">
                <div className="text-white text-[12.5px] font-semibold line-clamp-2">{v.title}</div>
                <div className="text-white/70 text-[11px]">{formatCount(v.views)} views · {v.channel?.name}</div>
              </div>
            </Link>
          ))}
          {list.length === 0 && <div className="text-white/55 col-span-full">No shorts in this category yet.</div>}
        </div>
      ) : (
        <div className="mt-6 grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
          {list.map(v => <VideoCard key={v.id} video={v} />)}
          {list.length === 0 && <div className="text-white/55">No videos in this category yet.</div>}
        </div>
      )}
    </div>
  );
}
